import { render } from "./OperationsTable.vue?vue&type=template&id=271b6984&scoped=true"
import script from "./OperationsTable.vue?vue&type=script&lang=js"
export * from "./OperationsTable.vue?vue&type=script&lang=js"

import "./OperationsTable.vue?vue&type=style&index=0&id=271b6984&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271b6984"],['__file',"resources/js/components/logs-managment/show/OperationsTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "271b6984"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('271b6984', __exports__)) {
    console.log('reload')
    api.reload('271b6984', __exports__)
  }
  
  module.hot.accept("./OperationsTable.vue?vue&type=template&id=271b6984&scoped=true", () => {
    console.log('re-render')
    api.rerender('271b6984', render)
  })

}


export default __exports__